import { Color, Spacing, Typography } from '@persona-id/design-tokens';
import { CircleHelpIcon } from '@persona-id/design-tokens/icons';
import { ComponentProps, FC, ReactNode } from 'react';
import styled from 'styled-components';

import Tooltip from 'dashboard/components/Tooltip';

const Container = styled.div`
  display: inline-block;

  color: ${({ theme }) => theme.color.text.tertiary};

  :hover {
    color: ${({ theme }) => theme.color.primary.brand};
  }
`;

export const IconContainer = styled.div`
  cursor: pointer;
  padding: 0 ${Spacing[2]};
`;

const DEFAULT_MESSAGE_CONTAINER_WIDTH = 250;

interface HelpIconProps extends Pick<ComponentProps<typeof Tooltip>, 'placement'> {
  className?: string;
  children: ReactNode;
  icon?: ReactNode;
  popoverWidth?: number | null;
  id?: string;
  'aria-label'?: string;
  'data-test'?: string;
}

const HelpIcon: FC<HelpIconProps> = ({
  className,
  children,
  icon = <CircleHelpIcon width={12} height={12} />,
  popoverWidth = DEFAULT_MESSAGE_CONTAINER_WIDTH,
  placement = 'top',
  id,
  'aria-label': ariaLabel = 'See help message',
  'data-test': dataTest,
}) => {
  return (
    <Container id={id} data-test={dataTest} className={className}>
      <Tooltip
        placement={placement}
        trigger='hover'
        tooltip={
          <TooltipTextWrapper
            style={{
              width: popoverWidth == null ? undefined : `${popoverWidth}px`,
            }}
          >
            {children}
          </TooltipTextWrapper>
        }
        hideArrow={true}
      >
        <IconContainer aria-label={ariaLabel}>{icon}</IconContainer>
      </Tooltip>
    </Container>
  );
};

const TooltipTextWrapper = styled.div`
  ${Typography.TextSmall};
  color: ${Color.TextSecondary};
`;

export default HelpIcon;
